"use strict";

import angular from "angular";

angular
    .module("nucont.accounting.mySubscription")
    .config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider.state("nucont.accounting.mySubscription", {
        url: "/minha-assinatura",
        lazyLoad(transition) {
            const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
            return import(
                /* webpackChunkName: "feature-accounting-my-subscription" */ "./my-subscription.entry"
            ).then(() =>
                $ocLazyLoad.inject("nucont.accounting.mySubscription")
            );
        },
        views: {
            "admin@nucont.accounting": {
                component: "mySubscriptionComponent"
            }
        },
        data: {
            layoutConfig: {
                model: "LayoutConfigModel4"
            }
        },
        bodyClass: "my-subscription-module"
    });
}
